import { ApiResponse, Job } from 'auth0'
import { nextApiRoutesClient } from 'modules/common/http/nextApiRoutesClient'

export interface PostVerificationEmailProps {
  userId: string | undefined
}
export const postVerificationEmail = async ({
  userId,
}: PostVerificationEmailProps) => {
  const { data } = await nextApiRoutesClient.post<ApiResponse<Job>>(
    '/api/auth/sendVerificationEmail',
    { userId }
  )

  return data
}
